var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.67725C6 5.09809 6.35982 4.84168 6.7989 5.10125L17.67 11.5279C18.1109 11.7885 18.1091 12.2123 17.67 12.4724L6.7989 18.899C6.35804 19.1597 6 18.8974 6 18.323V5.67673V5.67725Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4Icon);
export default __webpack_public_path__ + "static/media/mp4-icon.2e145cc8.svg";
export { ForwardRef as ReactComponent };